import React, { useRef, useState } from 'react'
import './CreateNewEditer.css'
import JoditEditor from 'jodit-react';
import { Link } from 'react-router-dom';

export default function CreateNewEditer(placeholder) {
  const editor = useRef(null);
  const [content, setContent] = useState('');
  const config = {
    placeholder: "Start typing...",
    autofocus: true,
    height: 250,
    allowResizeX: false,
    allowResizeY: false
  }
  return (
    <div className='TextEdifiter_total mt-3 '>
      <div>
        Global Warming_2022
      </div>
      <div className='d-flex justify-content-between mt-2'>
        <div className='d-flex gap-2'>
          <div className='subject_text'>Social Science</div>
          <div className='subject_text'>|</div>
          <div className='subject_text'>Lecture Content</div>
        </div>
        <Link to='/LibraryTemplate'><div className='addTemplate_title'>
          add templates
        </div>
        </Link>
      </div>
      <div className='ClimateChange_tiotal'>
        <input className='climate_change_input' placeholder='Climate Change' />
      </div>

      <div className='mt-3'>
        <JoditEditor
          ref={editor}
          value={content}
          config={config}
          onChange={newContent => { }}
        />
      </div>
      <div className='d-flex justify-content-end gap-2 mt-4'>
        <button className='Discard_text'>Save as Draft</button>
        <button className='Proceed_text'>Proceed</button>
      </div>

    </div>
  )
}
